export default {
    app: {
        name: 'Zunox',
        researchEdition: 'Research Edition',
    },
    nav: {
        activity: 'Активність',
        loading: 'Завантаження…',
        noActivityReports: 'Звітів про активність немає. Переконайтеся, що запущені AFK- та window-watcher.',
        timeline: 'Хронологія',
        stopwatch: 'Секундомір',
        tools: 'Інструменти',
        search: 'Пошук',
        workReport: 'Звіт про роботу',
        trends: 'Тренди',
        report: 'Звіт',
        alerts: 'Сповіщення',
        timespiral: 'Timespiral',
        query: 'Запити',
        graph: 'Граф',
        rawData: 'Сирі дані',
        settings: 'Налаштування',
    },
    footer: {
        madeWith: 'Зроблено з',
        byDevs: 'розробниками Zunox',
        host: 'Хост:',
        version: 'Версія:',
        reportBug: 'Повідомити про помилку',
        askHelp: 'Попросити допомогу',
        voteFeatures: 'Голосувати за функції',
        twitter: 'Twitter',
        github: 'GitHub',
        reddit: 'Reddit',
        donate: 'Підтримати',
    },
    common: {
        loading: 'Завантаження…',
        save: 'Зберегти',
        cancel: 'Скасувати',
        confirm: 'Підтвердити',
        import: 'Імпорт',
        export: 'Експорт',
        open: 'Відкрити',
        more: 'Ще',
        delete: 'Видалити',
        enabled: 'Увімкнено',
        disabled: 'Вимкнено',
        home: 'Головна',
        language: 'Мова',
        languageUk: 'Українська',
        languageEn: 'English',
        languageDe: 'Deutsch',
        languageRu: 'Русский',
        languageSv: 'Svenska',
        languageZhCN: '简体中文',
        rangeTo: 'до',
    },
    notFound: {
        title: 'Ой, цю сторінку не знайдено!',
        hint: 'Спробуйте повернутися туди, звідки прийшли.',
    },
    settings: {
        title: 'Налаштування',
        unsavedCategoriesLeave: 'У категоріях є незбережені зміни. Справді вийти?',
        daystart: {
            startOfDay: 'Початок дня',
            startOfDayHelp: 'Час, коли «починається» новий день — люди не завжди лягають спати до півночі. За замовчуванням 04:00.',
            startOfWeek: 'Початок тижня',
            startOfWeekHelp: 'День тижня, з якого починається новий тиждень.',
            saturday: 'Субота',
            sunday: 'Неділя',
            monday: 'Понеділок',
        },
        timelineDuration: {
            title: 'Тривалість за замовчуванням',
            help: 'Тривалість за замовчуванням для «показати останні» у хронології.',
        },
        landingPage: {
            title: 'Стартова сторінка',
            home: 'Головна',
            activity: 'Активність ({hostname})',
            timeline: 'Хронологія',
            help: 'Сторінка при відкритті Zunox або кліку на логотип у меню.',
        },
        theme: {
            title: 'Тема',
            auto: 'Авто (системна)',
            light: 'Світла',
            dark: 'Темна',
            help: 'Колірна тема інтерфейсу (кольори категорій для темного режиму потрібно налаштувати вручну).',
        },
        groups: {
            general: 'Загальні',
            generalHelp: 'Типові параметри періодів, хронології та стартової сторінки.',
            appearance: 'Зовнішній вигляд',
            appearanceHelp: 'Тема та кольори візуалізацій.',
            categorization: 'Категоризація',
            categorizationHelp: 'Правила класифікації подій у категорії та перевизначення AFK/активності.',
            privacy: 'Приватність',
            privacyHelp: 'Фільтри, що відкидають або приховують чутливі дані подій перед збереженням.',
            developer: 'Розробник',
        },
        language: {
            title: 'Мова',
            help: 'Мова інтерфейсу веб-застосунку.',
        },
        releaseNotification: {
            title: 'Перевірка нових версій',
            help: 'Якщо ввімкнено, веб-інтерфейс раз на день перевіряє наявність нової версії Zunox і показує підказку.',
        },
        color: {
            title: 'Резервні кольори',
            help: 'Старий стиль кольорів для деяких візуалізацій без категорії або без кольору категорії.',
        },
        activePattern: {
            title: 'Завжди рахувати активним (regex)',
            help1: 'Застосунки або заголовки за цим regex ніколи не будуть позначені як AFK.',
            help2: 'Корисно для зустрічей або ігор з геймпадом, коли немає вводу з клавіатури/миші. Порожній рядок вимикає правило.',
            example: 'Приклад виразу:',
            invalid: 'Некоректний шаблон',
            tooBroad: 'Занадто широкий шаблон',
        },
        categorization: {
            title: 'Категоризація',
            restoreDefaults: 'Скинути до типових',
            rulesHelp: 'Правила категоризації подій. Подія може мати лише одну категорію. Якщо підходить кілька — обирається найглибша.',
            builderIntro: 'Можна скористатися',
            categoryBuilder: 'Конструктором категорій',
            builderOutro: 'щоб швидко створити категорії з некатегоризованої активності.',
            forumIntro: 'Готові набори правил можна знайти на',
            forum: 'форумі',
            docsIntro: 'Довідка з написання правил — у',
            documentation: 'документації',
            categorySet: 'Набір категорій:',
            newSet: 'Новий набір',
            deleteSet: 'Видалити набір',
            setsAvailable: 'Доступно наборів: {count} — перемикайте профілі правил.',
            unsavedChanges: 'Є незбережені зміни!',
            discard: 'Відкинути',
            addCategory: 'Додати категорію',
            categories: 'Категорії',
            priority: 'Пріоритет',
            priorityDefault: 'Типовий',
            priorityInteger: 'Пріоритет має бути цілим числом.',
            builderTitle: 'Конструктор категорій',
            builderSubtitle: 'Створення правил із некатегоризованої активності',
            openBuilder: 'Відкрити конструктор',
            hideBuilder: 'Сховати конструктор',
        },
        developer: {
            title: 'Налаштування розробника',
            note: 'Увага:',
            noteBody: 'Ці параметри для розробників; необережна зміна може щось зламати.',
            forceDevmode: 'Примусовий devmode',
            forceDevmodeHelp: 'Devmode вмикає функції, що ще в розробці.',
            showYearly: 'Показувати річний діапазон',
            showYearlyHelp: 'Запит за цілий рік дуже важкий і часто завершується таймаутом. На aw-server-rust може працювати швидше.',
            multidevice: 'Запит з кількох пристроїв',
            multideviceHelp: 'Події з кількох хостів у перегляді активності. Експеримент; браузерні bucket-и та «аудіо = активність» поки не підтримуються.',
            requestTimeout: 'Таймаут запиту',
            requestTimeoutHelp: 'Максимальний час очікування відповіді сервера. Для великих запитів можна збільшити. Потрібно перезавантажити веб-інтерфейс.',
            commitHash: 'Хеш коміту веб-UI:',
        },
    },
    home: {
        note: 'Примітка:',
        androidNote: 'Zunox на Android на дуже ранній стадії. Будуть помилки, але ми працюємо над паритетом із десктопною версією (її варто спробувати!).',
        greeting: 'Ласкаво просимо до Zunox',
        intro1: 'Ми пройшли довгий шлях{android}, але нам ще потрібні користувачі (як ви!), щоб перетворити Zunox на успішний проєкт. Будемо раді почути ваші ідеї щодо покращень.',
        introAndroid: ' (особливо на Android!)',
        intro3: 'Якщо ви розробник, допоможіть watcher-ом, візуалізацією чи іншим — і поділіться на форумі!',
        thanks: 'Дякуємо, що користуєтеся Zunox!',
        surveyFill: 'Заповніть наше опитування',
        surveySuffix: 'щоб вплинути на те, що буде далі.',
        surveyOr: 'або',
        voteForum: 'проголосуйте за функції на форумі',
        spreadTitle: 'Поширюйте проєкт',
        spread1: 'Найкраща мотивація — коли Zunox потрапляє до нових людей. Діліться — і ми зробимо його ще кращим!',
        spreadReview: 'Залиште відгук на',
        spreadVote: 'Проголосуйте за нас на',
        spreadFollow: 'Слідкуйте та поширюйте в',
        spreadStar: 'Поставте зірку на',
        supportTitle: 'Підтримайте нас!',
        subscribeIntro: 'The best way to keep Zunox maintained is a subscription — from $5/month, every feature stays free, cancel anytime.',
        subscribeCta: 'Support Zunox →',
        support1: 'Подобається Zunox? Допоможіть нам допомогти вам — пожертва через:',
        support2: 'Детальніше — на',
        donationPage: 'сторінці пожертв на сайті',
        otherDonationMethods: 'Інші способи (зокрема криптовалюта)',
        resourcesTitle: 'Ресурси',
        website: 'Сайт',
        documentation: 'Документація',
        forum: 'Форум',
        discord: 'Discord',
        reddit: 'Reddit',
        apiBrowser: 'Оглядач API',
        workingOnTitle: 'Над чим ми працюємо',
        workingOnPrefix: 'Слідкуйте за',
        devUpdates: 'новинами розробки',
        workingOnMiddle: 'та за проєктом на',
        workingOnSuffix: 'щоб читати нотатки до релізів.',
        landingHint: 'Сторінку при відкритті Zunox (замість цієї) можна змінити в',
        supporterNudge: {
            message: "You've been getting a lot out of Zunox — would you consider supporting its development?",
            support: 'Support Zunox →',
            notNow: 'Not now',
        },
    },
    buckets: {
        title: 'Bucket-и',
        moreWatchers: 'Хочете збирати більше даних? Перегляньте',
        docsLink: 'документацію',
        thisDevice: 'цей пристрій',
        lastUpdatedInline: 'Останнє оновлення',
        noEventsYet: 'Подій ще не записано',
        noEvents: 'немає подій',
        moreActionsFor: 'Більше дій для {hostname}',
        deleteAllTitle: 'Видалити усі {count} bucket-и для {hostname}',
        deleteAllForHost: 'Видалити всі bucket-и цього хоста',
        openBucket: 'Відкрити bucket',
        deleteBucketTitle: 'Видалити bucket?',
        deleteHostTitle: 'Видалити bucket-и?',
        deleteHostTitleNamed: 'Видалити всі bucket-и для {hostname}?',
        deleteHostConfirmPrefix: 'Справді видалити',
        deleteHostConfirmCount: 'усі {count} bucket-и',
        deleteHostConfirmSuffix: 'для хоста «{hostname}»?',
        bucketsToDelete: 'Bucket-и, які будуть видалені:',
        deleting: 'Видалення…',
        importing: 'Імпорт…',
        importHelpNew: 'Потрібен JSON, експортований з одного або кількох bucket-ів. Імпорт не вдасться, якщо bucket з таким ID уже існує.',
        exportHelp: 'Завантажити всі bucket-и з цього сервера одним JSON-файлом. Для резервних копій.',
        currentDevice: '(поточний пристрій)',
        lastUpdated: 'Оновлено:',
        firstSeen: 'Вперше виявлено:',
        bucketId: 'ID bucket-а',
        updated: 'Оновлено',
        exportBucketJson: 'Експорт bucket-а в JSON',
        exportEventsCsv: 'Експорт подій у CSV',
        deleteBucket: 'Видалити bucket',
        deleteModalTitle: 'Небезпечно!',
        deleteConfirm: 'Видалити bucket «{id}»?',
        deletePermanent: 'Це назавжди і не скасувати!',
        importExportTitle: 'Імпорт і експорт bucket-ів',
        importBuckets: 'Імпорт bucket-ів',
        importPlaceholder: 'Оберіть або перетягніть файл…',
        importDrop: 'Перетягніть файл сюди…',
        importHelp: 'Потрібен JSON: експорт одного bucket-а або кількох. Якщо імена збігаються — імпорт не вдасться.',
        exportBuckets: 'Експорт bucket-ів',
        exportAllJson: 'Експорт усіх bucket-ів у JSON',
        tools: 'Інструменти',
    },
    activity: {
        title: 'Активність',
        for: 'для',
        host: 'Хост:',
        timeActive: 'Активний час:',
        queryRange: 'Діапазон запиту:',
        filters: 'Фільтри',
        filtersTitle: 'Фільтри',
        refresh: 'Оновити',
        excludeAfk: 'Виключити час AFK',
        audibleActive: 'Аудіо у вкладці браузера = активність',
        includeStopwatch: 'Включити ручні події (секундомір)',
        newView: 'Новий перегляд',
        loadDemo: 'Завантажити демо-дані',
        periodDay: 'день',
        periodWeek: 'тиждень',
        periodMonth: 'місяць',
        periodYear: 'рік',
        periodLast7d: '7 днів',
        periodLast30d: '30 днів',
        periodLast7dTitle: 'останні 7 днів',
        periodLast30dTitle: 'останні 30 днів',
        filterAfkTooltip: 'Приховати час, коли AFK-watcher не фіксував введення з клавіатури чи миші.',
        filterAudibleTooltip: 'Якщо активне вікно — вкладка браузера зі звуком, рахувати як активність. Потрібен browser watcher.',
        showCategory: 'Показати категорію',
        newViewTitle: 'Новий перегляд',
        viewId: 'ID',
        viewName: 'Назва',
        stopwatchWipNote: 'Увага: WIP. Події секундоміра перекривають інші при накладанні. Лише в devmode.',
        invalidForm: 'Некоректні дані форми: {errors}',
        errIdNotUnique: 'ID не унікальний',
        errMissingId: 'Немає ID',
        errMissingName: 'Немає назви',
    },
    activityView: {
        addVisualization: 'Додати візуалізацію',
        cancel: 'Скасувати',
        save: 'Зберегти',
        restoreDefaults: 'Скинути до типових',
        remove: 'Видалити',
        editView: 'Редагувати перегляд',
        restoreAlert: 'Усі перегляди скинуто до типових. Зміни не збережуться, доки не натиснете «Зберегти».',
        removeViewTitle: 'Видалити цей перегляд?',
        removeViewOk: 'Видалити перегляд',
        removeViewConfirm: 'Справді видалити',
        removeViewHint: 'Це видалить конфігурацію перегляду. Можна виконати',
        removeViewRestoreHint: 'щоб повернути типові перегляди.',
        promptWatcher: 'Введіть ім’я watcher',
        promptTitle: 'Введіть назву візуалізації',
    },
    uncategorized: {
        title: 'Багато некатегоризованого часу',
        body: 'Усього {duration} некатегоризованого часу — це {percent}% усього часу за {period}.',
        hint: 'Можна виправити через',
        categoryBuilder: 'Конструктор категорій',
        settingsCogTitle: 'Приховати або налаштувати цю підказку в параметрах',
        periodToday: 'сьогодні',
        periodThisWeek: 'цей тиждень',
        periodThisMonth: 'цей місяць',
        periodThisYear: 'цей рік',
        periodLast7d: 'останні 7 днів',
        periodLast30d: 'останні 30 днів',
    },
    visualizations: {
        noData: '(немає даних)',
        unsupportedPeriod: 'Ця функція не підтримує обраний період часу.',
        missingWatcher: 'Немає даних від потрібного watcher.',
        docLink: 'документації',
        allCategories: 'Усі',
        topApps: 'Топ застосунків',
        topTitles: 'Топ заголовків вікон',
        topDomains: 'Топ доменів браузера',
        topUrls: 'Топ URL браузера',
        topBrowserTitles: 'Топ заголовків браузера',
        topEditorFiles: 'Топ файлів редактора',
        topEditorLanguages: 'Топ мов редактора',
        topEditorProjects: 'Топ проєктів редактора',
        topCategories: 'Топ категорій',
        categoryTree: 'Дерево категорій',
        categorySunburst: 'Sunburst категорій',
        timelineBarchart: 'Хронологія (стовпчики)',
        sunburstClock: 'Sunburst годинник',
        dailyTimeline: 'Денна хронологія',
        customVis: 'Власна візуалізація',
        score: 'Оцінка',
        topStopwatches: 'Топ подій секундоміра',
        topBucketData: 'Топ даних bucket',
    },
    timeline: {
        title: 'Хронологія',
        eventsShown: 'Показано подій:',
        swimlanes: 'Доріжки:',
        filterAfk: 'Фільтр AFK',
        mergeByApp: 'Об’єднати за застосунком',
        noEvents: 'Немає подій за обраними критеріями. Хронологію не оновлено.',
        scrollHint: 'Коліщатко — масштаб, свайп/горизонтальна прокрутка — панорама, стрілки — навігація',
        loading: 'Завантаження…',
    },
    stopwatch: {
        title: 'Секундомір',
        usingBucket: 'Bucket:',
        aboutTitle: 'Про секундомір',
        aboutBody: 'Відстежуйте сесії, записані вручну, разом із автоматичним трекінгом. Щоб бачити підсумки секундоміра на панелі, відкрийте перегляд активності, натисніть «Редагувати перегляд», потім «Додати візуалізацію» і оберіть «Топ подій секундоміра».',
        placeholder: 'Над чим ви працюєте?',
        noRunning: 'Секундомір не запущено. Запустіть його вище, щоб відстежити зосереджену роботу.',
        start: 'Старт',
        running: 'Йде',
        history: 'Історія',
    },
    search: {
        title: 'Пошук',
        earlyDev: 'Функція ще на ранній стадії розробки.',
        searchBtn: 'Шукати',
        options: 'Параметри',
        notFound: 'Не знайшли потрібне?',
        addWeek: 'Додати тиждень до пошуку:',
        addWeekBtn: '+1 тиждень',
    },
    query: {
        title: 'Оглядач запитів',
        docsHelp: 'Довідка з написання запитів — у документації.',
        start: 'Початок',
        end: 'Кінець',
    },
    workReport: {
        title: 'Звіт про робочий час',
        loading: 'Завантаження…',
    },
    report: {
        title: 'Звіт',
        description: 'Звіт про час у певній категорії активності пристрою.',
        earlyDev: 'Функція ще на ранній стадії розробки.',
        generate: 'Згенерувати',
        options: 'Параметри',
        foundEvents: 'Знайдено подій: {count} за {seconds} с',
        csv: 'CSV',
    },
    trends: {
        titlePrefix: 'Тренди за',
        earlyDev: 'Функція ще на ранній стадії розробки.',
        loadDemo: 'Завантажити демо-дані',
    },
    timespiral: {
        title: 'Timespiral',
        wip: 'Експериментальна функція в розробці.',
        noAfkBucket: 'На цьому хості не знайдено AFK bucket. Встановіть',
        noAfkBucketSuffix: 'щоб користуватися Timespiral.',
        bucketLabel: 'Bucket:',
        eventsLabel: 'Подій:',
    },
};
